module.exports = __webpack_public_path__ + "static/media/coffee-glass.0b74130d.png";